import { ThisReceiver } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'g10-attendance-reports',
  templateUrl: './attendance-reports.component.html',
  styleUrls: ['./attendance-reports.component.css']
})
export class AttendanceReportsComponent implements OnInit {

  public matFormSize = '12px';
  public filterForm: FormGroup;
  public maxDate = new Date();
  public maxEndDate = new Date();
  date = new Date();
  public formSubmitted: boolean = false;
  public _activeMenu:string='Attendance report';
  public attendanceData = [];

  /* Pagination */
  pageNum = 1;
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  /* filters */
  public filterData = {};
  searchChangeObserver: any;
  public searchInputValue = '';

  public errorObject:any = {};

  public showTable: boolean = true;
  public tableData: any = [];
  public cols: any = [
    { key: '#', display: '#' },
    { key: 'empName', display: 'Employee name' ,headerConfig:{ isDefault: true}},
    { key: 'empRefID', display: 'Employee ID', config:{ isUppercase:true },headerConfig:{ isDefault: true} },
    {
      key: 'vehRegNo', display: 'Reg no',
      config: {
        isVehicle: true,
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'routeName', display: 'Route name' ,
    headerConfig:{ isDefault: true}},
    {
      key: 'scanTime', display: 'Date & Time', config: {
        isDate: true,
        format: 'dd/MM/YYYY HH:mm:ss'
      },
      headerConfig:{ isDefault: true}
    },
  ];
  public noDataFoundEnable: boolean = false;

  /* Excel */
  public attendanceExcelData:any = [];
  public excelData = {};
  public showDownloadBtn: boolean = false;  
  constructor(
    private api: ApiService, 
    private storage:StorageService,
    private fb: FormBuilder, 
    private com: CommonServices,
    private excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>
    ) {
      this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    }

  ngOnInit(): void {
    this.filterFormLoad();
    this.getAttendanceReport();
  }

  getAttendanceReport(page: number = 1, limit = 10, filter = null,) {
    let obj = { page, limit,};
    if (filter) {
      obj = { 
        ...obj, 
        ...filter,
      };
      this.filterData = { ...filter };
    }
    this.api.transportManagerEmpAttendanceReport(obj).then((res: any) => {
      if (res && res['status'] == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.attendanceData = res['data'];
          this.tableData = res['data'];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        else {
          this.tableData = [];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        this.processPagination(res, obj);
      }
      else {
        this.tableData = [];
        this.showTable = true;
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log('err', err);
    })

  }

  getAttendanceExlReport(obj){
      this.attendanceExcelData = [];
      this.api.transportManagerEmpAttendanceExlReport(obj).then(async (res: any) => {
        if (res && res.data && res.data.length > 0) {
              this.attendanceExcelData = res.data;
          }
      }).catch((err) => { console.log(err) })
  }

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getAttendanceReport(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getAttendanceReport(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
    this.getAttendanceReport(data.page, data.limit,filterObj);
  }

  filterFormLoad() {
    this.filterForm = this.fb.group({

      vehRegNo: new FormControl(''),
      empName: new FormControl(''),
      routeName: new FormControl(''),
      startDate: new FormControl('', [Validators.required]),
      endDate: new FormControl('', [Validators.required]),
    });
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.filterForm.controls[type].patchValue(x.getTime());
    });
  }

  setMaxDate() {
    let t_maxDate = new Date(this.filterForm.controls.startDate.value);

    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 30);

    if (new Date() > t_maxDate) {
      this.maxEndDate = t_maxDate;
      console.log('max date created')
    }
    else{
      this.maxEndDate = new Date();
    }
    this.checkValidation();
  }

  validation(data) {
    if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
    let objectKeys = Object.keys(data);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        let setDate = new Date(new Date(data.startDate).setDate(new Date(data.startDate).getDate()+30)).getTime();
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid End date';
        }
        else if(new Date(data.endDate).getTime() > setDate){
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid End date';
        }        
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {

    this.formSubmitted = true;
    this.showDownloadBtn = false;
    let checkObj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
      }
      if (this.filterForm.value.vehRegNo != '') obj['vehRegNo'] = this.filterForm.value.vehRegNo;
      if (this.filterForm.value.empName != '') obj['empName'] = this.filterForm.value.empName;
      if (this.filterForm.value.routeName != '') obj['routeName'] = this.filterForm.value.routeName;

      this.showDownloadBtn = true;
      this.getAttendanceReport(this.paginationData.page,this.paginationData.limit,obj);
      this.getAttendanceExlReport(obj);

    }
  }

  async exportToExcel() {
    let data = [];
    const startDate = new Date(this.filterForm.value.startDate + '');
    const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23, 59, 59));
    for (let i = 0; i < this.attendanceExcelData.length; i++) {
      let item = this.attendanceExcelData[i];
      try {
        let res = {
          value: [
            i + 1,
            item.empName ? this.com.convertTitleCase(item.empName) : '---',
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
            item.routeName ? this.com.convertTitleCase(item.routeName) : '---',
            item.scanTime ? this.com.timestampToDate(item.scanTime,'DMY H:M:S') : '---',
          ],
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }


    if (data.length > 0) {

      let rowCount = 2;
      let endCell = 'F';
      let customizedData = [];
      let titleRow = {
        value: ['Attendance Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },

        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);

      rowCount = rowCount + 2;

      let subtitleRow = {
        value: [
          "Start Date       : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date         : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Employee name','Employee ID', 'Reg no', 'Route name','Scan time'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData.push(...data);

      if (this.excelData['Attendance_Report'] == undefined) { this.excelData['Attendance_Report'] = {}; }

      this.excelData['Attendance_Report'] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 20 },{ colNo: 4, width: 20 }, { colNo: 5, width: 25 }, { colNo: 6, width: 25 }]
        }
      };// excelInfo;

      this.downloadExlReport();

    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Attendance_Report_' +this.com.timestampToDate(new Date().getTime(),'DMY' )  + '.xlsx');
  }


}
